var _rect, _g, _circle, _g2, _circle2, _g3, _circle3, _g4, _circle4, _g5, _circle5, _g6, _circle6, _g7, _circle7, _g8, _circle8, _g9, _circle9, _g10, _circle10, _g11, _circle11, _g12, _circle12, _g13, _circle13, _g14, _circle14, _g15, _circle15, _g16, _circle16, _g17, _circle17, _g18, _circle18, _g19, _circle19, _g20, _circle20, _g21, _circle21, _g22, _circle22, _g23, _circle23, _g24, _circle24, _g25, _circle25, _g26, _circle26, _g27, _circle27, _g28, _circle28, _g29, _circle29, _g30, _circle30, _g31, _circle31, _g32, _circle32, _path, _g33, _rect2, _rect3, _rect4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect5, _ellipse5, _rect6, _ellipse6, _path2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path3, _path4, _path5, _path6, _rect14, _rect15, _path7, _g34, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _rect16, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 800,
    viewBox: "0 0 1440 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    fill: "#0C091E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1193,
    cy: 53,
    r: 2,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1193,
    cy: 53,
    r: 2,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 85,
    r: 2,
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 85,
    r: 2,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 59,
    r: 2,
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 59,
    r: 2,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1016,
    cy: 28,
    r: 2,
    fill: "white"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1016,
    cy: 28,
    r: 2,
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 883,
    cy: 65,
    r: 2,
    fill: "white"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 883,
    cy: 65,
    r: 2,
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 65,
    r: 2,
    fill: "white"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 65,
    r: 2,
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 677,
    cy: 32,
    r: 2,
    fill: "white"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 677,
    cy: 32,
    r: 2,
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 963,
    cy: 213,
    r: 2,
    fill: "white"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 963,
    cy: 213,
    r: 2,
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 408,
    r: 2,
    fill: "white"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 408,
    r: 2,
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1299,
    cy: 740,
    r: 2,
    fill: "white"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1299,
    cy: 740,
    r: 2,
    fill: "white"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1018,
    cy: 768,
    r: 2,
    fill: "white"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1018,
    cy: 768,
    r: 2,
    fill: "white"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1312,
    cy: 452,
    r: 2,
    fill: "white"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1312,
    cy: 452,
    r: 2,
    fill: "white"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1394,
    cy: 664,
    r: 2,
    fill: "white"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1394,
    cy: 664,
    r: 2,
    fill: "white"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1400,
    cy: 318,
    r: 2,
    fill: "white"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1400,
    cy: 318,
    r: 2,
    fill: "white"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 466,
    r: 2,
    fill: "white"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 466,
    r: 2,
    fill: "white"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 805,
    cy: 452,
    r: 2,
    fill: "white"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 805,
    cy: 452,
    r: 2,
    fill: "white"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 943,
    cy: 586,
    r: 2,
    fill: "white"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 943,
    cy: 586,
    r: 2,
    fill: "white"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1400,
    cy: 507,
    r: 2,
    fill: "white"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1400,
    cy: 507,
    r: 2,
    fill: "white"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1178,
    cy: 474,
    r: 2,
    fill: "white"
  }))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1178,
    cy: 474,
    r: 2,
    fill: "white"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 30,
    r: 2,
    fill: "white"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 30,
    r: 2,
    fill: "white"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 206,
    r: 2,
    fill: "white"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 206,
    r: 2,
    fill: "white"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 887,
    cy: 303,
    r: 2,
    fill: "white"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 887,
    cy: 303,
    r: 2,
    fill: "white"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 508,
    cy: 207,
    r: 2,
    fill: "white"
  }))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 508,
    cy: 207,
    r: 2,
    fill: "white"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 574,
    cy: 309,
    r: 2,
    fill: "white"
  }))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 574,
    cy: 309,
    r: 2,
    fill: "white"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 730,
    r: 2,
    fill: "white"
  }))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 730,
    r: 2,
    fill: "white"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 523,
    cy: 522,
    r: 2,
    fill: "white"
  }))), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 523,
    cy: 522,
    r: 2,
    fill: "white"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 682,
    r: 2,
    fill: "white"
  }))), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 682,
    r: 2,
    fill: "white"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 736,
    r: 2,
    fill: "white"
  }))), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 736,
    r: 2,
    fill: "white"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 766,
    r: 2,
    fill: "white"
  }))), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 766,
    r: 2,
    fill: "white"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 314,
    r: 2,
    fill: "white"
  }))), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 314,
    r: 2,
    fill: "white"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 521,
    r: 2,
    fill: "white"
  }))), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 521,
    r: 2,
    fill: "white"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 647,
    r: 2,
    fill: "white"
  }))), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 647,
    r: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M946.477 445.874C954.902 375.666 1017.51 360.564 1071.48 314.874C1098.06 292.365 1116.48 284.059 1142.48 260.874C1188.38 219.938 1182.81 130.207 1244.48 140.874C1306.14 151.54 1369.4 129.663 1399.98 184.874C1434.89 247.916 1365.48 242.374 1321.48 351.874C1277.48 461.374 1381.84 444.187 1379.48 509.874C1377.98 551.688 1350.18 571.033 1349.98 612.874C1349.7 668.179 1422.52 694.871 1399.98 745.374C1372.48 806.967 1228.48 765.874 1228.48 765.874C1176.64 775.874 1012.77 815.914 1005.48 727.874C1001.2 676.27 1067.1 664.469 1071.48 612.874C1078.37 531.703 936.772 526.757 946.477 445.874Z",
    fill: "#E5E5E5",
    fillOpacity: 0.06
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M906.214 552.376C846.949 557.959 815.047 628.111 854.305 676.013C872.447 698.233 902.743 709.224 932.603 701.58C948.601 697.481 962.433 688.384 972.286 676.548C1015.32 625.134 974.783 545.876 906.214 552.376Z",
    fill: "url(#paint0_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.415 683.028C892.579 683.028 874.426 671.552 865.029 654.606C844.296 617.243 872.893 571.887 914.637 573.215C941.193 573.751 963.624 593.21 967.904 619.087C973.519 652.484 947.565 683.028 913.415 683.028Z",
    fill: "url(#paint1_radial_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M935.349 636.991C933.059 636.424 932.427 639.257 933.722 639.896C935.018 640.545 938.271 642.482 938.924 641.184C939.576 639.896 937.95 637.64 935.349 636.991Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.092 613.092C955.874 613.597 953.222 614.709 955.491 616.327C957.77 617.944 961.335 617.295 961.666 615.358C961.987 613.411 962.319 612.124 958.092 613.092Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.581 665.093C908.814 662.25 901.883 661.22 901.23 664.125C900.577 667.03 905.126 671.552 910.648 670.903C916.181 670.264 916.834 667.03 913.581 665.093Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.122 680.772C924.822 682.039 920.305 682.801 915.632 682.976C916.699 676.249 923.133 678.371 926.573 679.299C927.578 679.577 928.418 680.123 929.122 680.772Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.368 664.774C885.471 665.691 886.942 661.22 884.02 657.346C881.099 653.473 879.793 648.621 876.218 647.653C872.644 646.685 870.696 659.283 883.368 664.774Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.069 648.941C867.919 649.147 867.443 651.526 870.043 651.845C872.644 652.175 872.644 648.302 869.069 648.941Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.987 635.703C895.697 635.497 893.439 636.672 893.76 639.257C894.081 641.843 897.656 639.257 899.282 639.257C900.909 639.257 901.562 636.023 897.987 635.703Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.408 605.665C918.44 604.738 918.129 608.899 919.756 609.538C921.382 610.187 925.931 608.24 920.408 605.665Z",
    fill: "#056DB1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M899.614 626.659C888.569 628.596 886.942 628.915 876.871 637.321C870.209 642.873 863.257 641.081 859.32 639.226C858.584 635.642 858.19 631.923 858.19 628.111C858.19 612.495 864.749 598.392 875.276 588.4C877.441 589.677 879.679 591.408 881.42 593.715C886.289 600.174 885.315 602.76 899.614 610.187C913.902 617.614 910.659 624.722 899.614 626.659Z",
    fill: "url(#paint2_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.334 604.583C953.139 602.461 946.187 613.926 939.245 613.092C931.122 612.124 933.401 600.174 926.573 587.575C923.154 581.271 922.916 576.903 923.527 574.122C941.172 577.357 955.864 588.935 963.334 604.583Z",
    fill: "url(#paint3_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.65 628.111C968.65 649.425 956.444 667.895 938.602 677.001C934.531 670.604 941.131 665.855 948.995 660.9C958.744 654.761 949.647 652.175 951.264 642.162C952.89 632.149 946.715 631.5 949.637 623.105C951.72 617.109 962.578 622.796 968.618 626.545C968.639 627.061 968.65 627.586 968.65 628.111Z",
    fill: "url(#paint4_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.834 644.748C910.928 646.571 907.737 639.577 900.266 641.194C892.796 642.811 886.621 656.049 896.692 655.729C906.763 655.41 909.363 654.112 916.834 659.283C924.304 664.454 933.08 660.9 935.68 652.824C938.271 644.748 936.644 638.608 916.834 644.748Z",
    fill: "url(#paint5_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.174 620.519C926.066 621.508 925.278 623.105 926.252 625.042C927.226 626.978 931.122 626.659 933.07 629.564C935.018 632.469 939.898 636.023 941.193 629.564C942.498 623.105 936.323 618.253 929.174 620.519Z",
    fill: "url(#paint6_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M917.808 603.718C917.228 608.024 913.259 603.718 906.763 602.43C900.266 601.142 897.666 597.259 900.588 594.673C903.509 592.088 907.405 590.151 911.311 592.407C915.207 594.673 918.45 598.876 917.808 603.718Z",
    fill: "#056DB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.98 578.201C902.857 578.201 898.961 582.724 891.491 585.309C887.035 586.844 883.513 585.062 881.389 583.373C890.423 576.965 901.479 573.195 913.425 573.195C913.839 573.195 914.243 573.195 914.648 573.216C915.217 575.544 915.01 578.201 910.98 578.201Z",
    fill: "url(#paint7_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M966.018 644.913C961.511 658.871 951.533 670.398 938.602 677.001C935.587 678.536 932.417 679.803 929.122 680.782C924.822 682.049 920.305 682.811 915.632 682.986C914.896 683.017 914.161 683.028 913.415 683.028C892.579 683.028 874.426 671.552 865.028 654.606C862.397 649.868 860.449 644.696 859.32 639.226C858.584 635.642 858.19 631.923 858.19 628.111C858.19 621.477 859.371 615.121 861.537 609.239C867.785 627.792 882.083 651.732 914.585 656.172C920.926 657.037 926.853 657.151 932.386 656.677C945.959 655.492 957.128 650.774 966.018 644.913Z",
    fill: "url(#paint8_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M968.65 628.111C968.65 633.973 967.727 639.618 966.018 644.913C961.511 658.871 951.533 670.398 938.602 677.001C935.587 678.536 932.417 679.803 929.122 680.782C924.822 682.049 920.305 682.811 915.632 682.986C914.896 683.017 914.161 683.028 913.415 683.028C892.579 683.028 874.426 671.552 865.029 654.606C874.581 658.51 885.958 661.178 899.448 661.704C912.534 662.219 923.392 660.21 932.386 656.667C951.72 649.064 962.495 634.354 968.339 622.239C968.494 623.651 968.587 625.093 968.629 626.535C968.639 627.06 968.65 627.586 968.65 628.111Z",
    fill: "url(#paint9_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.914 619.118C967.914 619.118 960.05 590.48 923.89 581.055C902.214 575.399 887.17 580.498 878.602 585.484C905.965 563.275 947.813 572.092 963.334 604.583C966.94 612.113 967.655 618.067 967.914 619.118Z",
    fill: "url(#paint10_linear_1_2)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 160.252,
    height: 150.433,
    rx: 15,
    transform: "matrix(0.835813 0.549014 -0.549051 0.835789 1215.76 162.911)",
    fill: "#686767"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 160.252,
    height: 3.27028,
    transform: "matrix(0.835813 0.549014 -0.549051 0.835789 1193.31 197.076)",
    fill: "#595959"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 160.252,
    height: 3.27027,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1184.33 210.742)",
    fill: "#595959"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.27046,
    cy: 3.2703,
    rx: 3.27046,
    ry: 3.2703,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1205.49 187.47)",
    fill: "#7D7D7D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.2704,
    cy: 3.27026,
    rx: 3.2704,
    ry: 3.27026,
    transform: "matrix(0.835811 0.549017 -0.549049 0.835791 1323.03 264.677)",
    fill: "#7D7D7D"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.27043,
    cy: 3.27026,
    rx: 3.27043,
    ry: 3.27026,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1184.84 218.902)",
    fill: "#7D7D7D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.27046,
    cy: 3.2703,
    rx: 3.27046,
    ry: 3.2703,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1302.38 296.11)",
    fill: "#7D7D7D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 31.0692,
    height: 83.392,
    rx: 10,
    transform: "matrix(0.999318 -0.0369264 0.0368827 0.99932 1261.44 282.835)",
    fill: "#D6D6D6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6289,
    cy: 10.6284,
    rx: 10.6289,
    ry: 10.6284,
    transform: "matrix(0.999318 -0.0369266 0.0368825 0.99932 1275.29 347.774)",
    fill: "url(#paint11_radial_1_2)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 31.0692,
    height: 83.392,
    rx: 10,
    transform: "matrix(-0.294269 -0.955723 -0.95571 0.29431 1211.3 252.126)",
    fill: "#D6D6D6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6289,
    cy: 10.6284,
    rx: 10.6289,
    ry: 10.6284,
    transform: "matrix(-0.294269 -0.955723 -0.95571 0.294311 1146.38 260.662)",
    fill: "url(#paint12_radial_1_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1232.82 351.181L1163.12 305.396L1123.72 365.369C1120.69 369.985 1121.97 376.185 1126.59 379.217L1136.52 385.743C1141.14 388.775 1147.34 387.492 1150.37 382.876L1169.01 354.506C1171.8 350.26 1177.5 349.079 1181.75 351.868C1185.99 354.657 1187.18 360.36 1184.39 364.605L1165.75 392.975C1162.72 397.591 1164 403.791 1168.62 406.823L1179.58 414.023C1184.19 417.055 1190.39 415.771 1193.43 411.155L1232.82 351.181Z",
    fill: "#D6D6D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 106.289,
    height: 103.014,
    transform: "matrix(0.835813 0.549014 -0.549051 0.835789 1208.32 215.747)",
    fill: "#E1E1E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 99.7485,
    height: 29.4325,
    transform: "matrix(0.835813 0.549014 -0.549051 0.835789 1163.47 289.974)",
    fill: "#E1E1E1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 8.17611,
    height: 103.014,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1221.98 224.725)",
    fill: "url(#paint13_linear_1_2)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.17612,
    height: 103.014,
    transform: "matrix(0.835813 0.549014 -0.549052 0.835788 1273.92 258.84)",
    fill: "url(#paint14_linear_1_2)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 106.289,
    height: 3.27027,
    transform: "matrix(0.835813 0.549014 -0.549051 0.835789 1153.55 299.112)",
    fill: "#9A9A9A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.4466,
    height: 26.1622,
    rx: 5.72329,
    transform: "matrix(0.835814 0.549014 -0.549052 0.835788 1319.6 239.936)",
    fill: "#D6D6D6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 11.4465,
    height: 26.1622,
    rx: 5.72327,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1221.19 175.297)",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.31 253.425C1298.53 280.481 1262.19 288.006 1235.13 270.233C1208.07 252.459 1200.55 216.117 1218.32 189.061C1236.1 162.004 1272.44 154.479 1299.5 172.253C1326.56 190.027 1334.08 226.369 1316.31 253.425Z",
    fill: "#D6D6D6",
    stroke: "#E1E1E1",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1315.55 254.88C1297.11 279.848 1262.15 286.322 1235.89 269.075C1209.64 251.828 1201.69 217.171 1217.29 190.339C1216.65 191.211 1216.02 192.106 1215.42 193.023C1197.57 220.195 1205.13 256.692 1232.3 274.541C1259.48 292.391 1295.97 284.834 1313.82 257.662C1314.43 256.745 1315 255.817 1315.55 254.88Z",
    fill: "#DDDDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311.95 260.346C1293.52 285.315 1258.56 291.788 1232.3 274.541C1206.05 257.294 1198.1 222.638 1213.7 195.806C1213.05 196.678 1212.43 197.573 1211.83 198.49C1193.98 225.662 1201.54 262.158 1228.71 280.008C1255.88 297.857 1292.38 290.3 1310.23 263.129C1310.84 262.211 1311.41 261.284 1311.95 260.346Z",
    fill: "#D6D6D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.16 233.79C1313.39 211.401 1268.5 179.959 1239.88 172.897C1218.45 189.142 1207.14 213.533 1216.97 239.039C1222.43 253.201 1230 260.081 1243.02 267.887C1252.65 273.662 1259.07 276.61 1270.29 276.999C1296.64 277.912 1318.86 249.232 1322.16 233.79Z",
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1250.48,
    y: 285.255,
    width: 3.27044,
    height: 1.63515,
    rx: 0.817574,
    transform: "rotate(13.3007 1250.48 285.255)",
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.63528,
    height: 1.63508,
    rx: 0.817539,
    transform: "matrix(0.973176 0.230061 -0.230062 0.973176 1257.74 286.113)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1213,
    y: 172,
    width: 110,
    height: 106
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.16 233.792C1313.39 211.402 1268.5 179.96 1239.88 172.898C1218.45 189.144 1207.14 213.535 1216.97 239.04C1222.43 253.202 1230 260.083 1243.02 267.888C1252.65 273.663 1259.07 276.611 1270.29 277C1296.64 277.914 1318.86 249.233 1322.16 233.792Z",
    fill: "black"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3516,
    height: 90.6049,
    transform: "matrix(0.369765 0.929126 -0.929149 0.369707 1283.76 178.331)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.22658,
    height: 95.5158,
    transform: "matrix(0.369764 0.929126 -0.929149 0.369707 1300.67 200.532)",
    fill: "#484848"
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6289,
    cy: 10.6284,
    rx: 10.6289,
    ry: 10.6284,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1241.19 180.604)",
    fill: "#828282",
    fillOpacity: 0.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.72329,
    cy: 5.72298,
    rx: 5.72329,
    ry: 5.72298,
    transform: "matrix(0.835814 0.549013 -0.549053 0.835788 1254.85 189.581)",
    fill: "#828282",
    fillOpacity: 0.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.08804,
    cy: 4.08785,
    rx: 4.08804,
    ry: 4.08785,
    transform: "matrix(0.835812 0.549016 -0.54905 0.83579 1232.21 194.27)",
    fill: "#828282",
    fillOpacity: 0.5
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.08805,
    cy: 4.08785,
    rx: 4.08805,
    ry: 4.08785,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1262.85 165.491)",
    fill: "#BC0D0D"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.08808,
    cy: 4.08786,
    rx: 4.08808,
    ry: 4.08786,
    transform: "matrix(0.835814 0.549013 -0.549053 0.835788 1281.48 169.899)",
    fill: "#BC0D0D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 44.151,
    height: 22.8919,
    rx: 5,
    transform: "matrix(0.835813 0.549015 -0.549051 0.835789 1204.19 275.639)",
    fill: "#273AE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.63 293.634L1214.67 294.996L1220.7 297.733L1205.72 300.118",
    stroke: "#D2CB15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M383.5 268.5C329 191 204.113 21.5 79.1125 82.5C-45.8876 143.5 66 122.5 70 195C74 267.5 80.5001 284 61.5 328C24.2889 414.173 22.2247 520.5 56.6123 568C91 615.5 309.612 788 381.112 777.5C452.612 767 438.112 643 396.612 577.5C355.112 512 172.61 602.47 283.613 503C322.113 468.5 415.112 540 438.112 540C461.112 540 541.863 483.73 473.112 388C399.5 285.5 438 346 383.5 268.5Z",
    fill: "#E5E5E5",
    fillOpacity: 0.06
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_2",
    x: 1186,
    y: 46,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_2",
    x: 277,
    y: 78,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_2",
    x: 65,
    y: 52,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_2",
    x: 1009,
    y: 21,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_2",
    x: 876,
    y: 58,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1_2",
    x: 1383,
    y: 58,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1_2",
    x: 670,
    y: 25,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1_2",
    x: 956,
    y: 206,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1_2",
    x: 1113,
    y: 401,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1_2",
    x: 1292,
    y: 733,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1_2",
    x: 1011,
    y: 761,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1_2",
    x: 1305,
    y: 445,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1_2",
    x: 1387,
    y: 657,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1_2",
    x: 1393,
    y: 311,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_1_2",
    x: 627,
    y: 459,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_1_2",
    x: 798,
    y: 445,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_1_2",
    x: 936,
    y: 579,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_1_2",
    x: 1393,
    y: 500,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_1_2",
    x: 1171,
    y: 467,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_1_2",
    x: 348,
    y: 23,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_1_2",
    x: 36,
    y: 199,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_1_2",
    x: 880,
    y: 296,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_1_2",
    x: 501,
    y: 200,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_1_2",
    x: 567,
    y: 302,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_1_2",
    x: 787,
    y: 723,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_1_2",
    x: 516,
    y: 515,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_1_2",
    x: 557,
    y: 675,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_1_2",
    x: 282,
    y: 729,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_1_2",
    x: 36,
    y: 759,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_1_2",
    x: 318,
    y: 307,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_1_2",
    x: 94,
    y: 514,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_1_2",
    x: 148,
    y: 640,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(913.497 628.003) scale(65.9981 65.6176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90DD6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8FFA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(916.157 606.621) scale(67.0302 66.6438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056DB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 877.125,
    y1: 543.447,
    x2: 889.651,
    y2: 701.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F236",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 939.103,
    y1: 538.532,
    x2: 951.628,
    y2: 696.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F236",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 944.024,
    y1: 538.142,
    x2: 956.549,
    y2: 696.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F236",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2",
    x1: 905.323,
    y1: 541.211,
    x2: 917.848,
    y2: 699.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F236",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2",
    x1: 926.709,
    y1: 539.515,
    x2: 939.235,
    y2: 697.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F236",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2",
    x1: 895.161,
    y1: 542.017,
    x2: 907.687,
    y2: 699.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F236",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2",
    x1: 905.019,
    y1: 699.204,
    x2: 913.209,
    y2: 624.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0983BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2",
    x1: 910.589,
    y1: 695.975,
    x2: 919.743,
    y2: 617.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A9D7",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2",
    x1: 953.528,
    y1: 542.95,
    x2: 919.083,
    y2: 611.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2FFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFB3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0818 13.0811) rotate(-156.802) scale(6.22669 6.22647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0818 13.0811) rotate(-156.802) scale(6.22669 6.22647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_2",
    x1: 4.08805,
    y1: 0,
    x2: 4.08805,
    y2: 103.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_2",
    x1: 4.08806,
    y1: 0,
    x2: 4.08806,
    y2: 103.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232030"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 152,
    fill: "white",
    transform: "translate(837 552)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.cf2b082c065d8127a747423be7a4ace2.svg";
export { ForwardRef as ReactComponent };